module.exports = __webpack_public_path__ + "static/media/unblocking.24096035.png";